/* eslint-disable */
import React from 'react'
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'
import Home from './pages/Home'
import Play from './pages/Play'
import InterferenceDiffraction from './pages/InterferenceDiffraction'
import MomentOfInertia from './pages/MomentOfInertia'
import BuildAnAtom from './pages/BuildAnAtom'
import OpenStax from './pages/OpenStax'

function AppContent() {
  const location = useLocation()
  const isInterferenceDiffraction = location.pathname === '/interference-diffraction'
  const isMomentOfInertia = location.pathname === '/moment-of-inertia'
  const isBuildAnAtom = location.pathname === '/openstax/build-an-atom'
  const isPlayRoute = location.pathname.startsWith('/play/')

  return (
    <div className={isInterferenceDiffraction || isMomentOfInertia || isBuildAnAtom || isPlayRoute ? '' : 'w-full px-2 md:px-4'}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/play/:id" element={<Play />} />
        <Route path="/interference-diffraction" element={<InterferenceDiffraction />} />
        <Route path="/moment-of-inertia" element={<MomentOfInertia />} />
        <Route path="/openstax/build-an-atom" element={<BuildAnAtom />} />
        <Route path="/openstax/:slug" element={<OpenStax />} />
      </Routes>
    </div>
  )
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App
